import query from './query';
import Component from '../../components/Component';
import Loading from '../../components/Loading';
import Pairs from './Pairs';
import Entity from './Entity';
import { withTranslation } from 'react-i18next';
import SelectComponent from './Select';

class SearchTopEntities extends Component {
    constructor() {
        super();

        this.urlParams = new URLSearchParams(window.location.search);
        this.entity = this.urlParams.get('entity');

        this.query = query();

        this.onSelect = this.onSelect.bind(this);
        this.onChangeTab = this.onChangeTab.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.repeat && this.entity) {
            this.onSelect(this.entity);
            this.setState({
                repeat: true,
            });
        }
    }

    onSelect(value) {
        this.setState({
            entity: value,
            tab: 'entity',
        });
    }

    onChangeTab(key) {
        this.setState({
            tab: key,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="row card-row d-flex" id="summary">
                    <div className="col-12">
                        <div
                            className="card table-main rounded-main overflow-hidden "
                            id="domain-summery"
                        >
                            <div className="card-header">
                                <p className="card-title">{t('discover.entity_clusters.header')}</p>
                            </div>
                            <div className="card-body">
                                {this.state.loading ? (
                                    <Loading />
                                ) : (
                                    <SelectComponent
                                        data={this.state.data}
                                        onSelect={this.onSelect}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.tab && (
                    <div className="tags-container">
                        <button
                            className={`tab-item ${
                                this.state.tab === 'all' ? 'active-tag' : 'not-active'
                            }`}
                            onClick={() => this.onChangeTab('all')}
                        >
                            {t('discover.entity_clusters.all')}
                        </button>
                        <button
                            className={`tab-item ${
                                this.state.tab === 'entity' ? 'active-tag' : 'not-active'
                            }`}
                            onClick={() => this.onChangeTab('entity')}
                        >
                            "{this.state.entity}" {t('discover.entity_clusters.header')}
                        </button>
                    </div>
                )}
                <div
                    className="row card-row"
                    id="summary"
                    style={{
                        display: !this.state.tab || this.state.tab === 'all' ? 'flex' : 'none',
                    }}
                >
                    <div className="col-12">
                        <div
                            className="card table-main rounded-main overflow-hidden "
                            id="domain-summery"
                        >
                            <Pairs onSelect={this.onSelect} />
                        </div>
                    </div>
                </div>
                <div style={{ display: this.state.tab === 'entity' ? 'block' : 'none' }}>
                    {this.state.entity && <Entity entity={this.state.entity} />}
                </div>
            </>
        );
    }
}

export default withTranslation()(SearchTopEntities);
